<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-06-05 17:54:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-16 09:45:32
-->
<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout"
export default {
  components: {
    PageHeaderLayout
  },
  data() {
    return {
    }
  },
  methods: {
  },

  created() {
  },
  mounted() {
  },
}
</script>

<style lang="stylus" scoped>
</style>
